export enum RecentSearchDataType {
  Cars = 'Cars',
  Hotel = 'Hotel',
  Flight = 'Flight',
  Bus = 'Bus',
  Packages = 'Packages',
  ByHours = 'ByHours',
  Activities = 'Activities',
}
